var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "150px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间", prop: "houseId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      staticStyle: { width: "300px" },
                      attrs: {
                        disabled: "",
                        remote: "",
                        "remote-method": _vm.getCustomerInfo,
                        filterable: "",
                        placeholder: "请输入房间代码"
                      },
                      on: { change: _vm.customerChange },
                      model: {
                        value: _vm.childData.houseId,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "houseId", $$v)
                        },
                        expression: "childData.houseId"
                      }
                    },
                    _vm._l(_vm.houseList, function(item) {
                      return _c("el-option", {
                        key: item.houseId,
                        attrs: {
                          label:
                            item.houseCode +
                            "(" +
                            item.buildingName +
                            "-" +
                            item.unintName +
                            ")",
                          value: parseInt(item.houseId)
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "原仪表名称",
                    disabled: "",
                    prop: "meterNameOld"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.meterNameOld,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "meterNameOld", $$v)
                      },
                      expression: "childData.meterNameOld"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "仪表类型", prop: "meterId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      staticStyle: { width: "300px" },
                      attrs: {
                        disabled: "",
                        filterable: "",
                        placeholder: "请选择仪表类型"
                      },
                      model: {
                        value: _vm.childData.meterId,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "meterId", $$v)
                        },
                        expression: "childData.meterId"
                      }
                    },
                    _vm._l(_vm.meterTypeList, function(item) {
                      return _c("el-option", {
                        key: item.meterId,
                        attrs: {
                          label: item.meterName,
                          value: parseInt(item.meterId)
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "原仪表上次读数", prop: "lastReadNumberOld" }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.lastReadNumberOld,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "lastReadNumberOld", $$v)
                      },
                      expression: "childData.lastReadNumberOld"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "原仪表上次读数日期",
                    prop: "lastReadDateOld"
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    staticStyle: { width: "300px" },
                    attrs: {
                      disabled: "",
                      type: "date",
                      placeholder: "请选择更换日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.childData.lastReadDateOld,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "lastReadDateOld", $$v)
                      },
                      expression: "childData.lastReadDateOld"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "原仪表更换时读数", prop: "changeReadNumber" }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    model: {
                      value: _vm.childData.changeReadNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "changeReadNumber", $$v)
                      },
                      expression: "childData.changeReadNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "新仪表名称",
                    disabled: "",
                    prop: "meterName"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    model: {
                      value: _vm.childData.meterName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "meterName", $$v)
                      },
                      expression: "childData.meterName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "更换日期", prop: "initDate" } },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择更换日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.childData.initDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "initDate", $$v)
                      },
                      expression: "childData.initDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新仪表最大读数", prop: "maxReadNumber" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    model: {
                      value: _vm.childData.maxReadNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "maxReadNumber", $$v)
                      },
                      expression: "childData.maxReadNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新仪表初始读数", prop: "initReadNumber" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    model: {
                      value: _vm.childData.initReadNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "initReadNumber", $$v)
                      },
                      expression: "childData.initReadNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "倍率", prop: "meterMagnification" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    model: {
                      value: _vm.childData.meterMagnification,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "meterMagnification", $$v)
                      },
                      expression: "childData.meterMagnification"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "损耗率", prop: "wastingRate" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    model: {
                      value: _vm.childData.wastingRate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "wastingRate", $$v)
                      },
                      expression: "childData.wastingRate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }